import type { MouseEventHandler, ReactNode } from 'react';

import { Button, type ButtonProps } from '../../core/button/Button';

export type StatefulButtonProps = {
    readonly children: ReactNode;
    readonly status?: ReactNode;
    readonly variant?: ButtonProps['variant'];
    readonly size?: ButtonProps['size'];
    readonly disabled?: boolean;
    readonly onClick?: MouseEventHandler<HTMLButtonElement>;
    readonly className?: string;
    readonly type?: 'button' | 'reset' | 'submit';
};

export function StatefulButton({
    children,
    status,
    variant = 'solid',
    size = 'sm',
    disabled,
    onClick,
    className,
    type = 'button',
}: StatefulButtonProps) {
    const justify = status ? '!justify-between' : '!justify-start';
    return (
        <Button
            variant={variant}
            size={size}
            disabled={disabled}
            onClick={onClick}
            type={type}
            className={`w-full gap-xs text-left ${justify} ${className ?? ''}`}
        >
            <span className="min-w-0 flex-1 truncate text-left">{children}</span>
            {status ? <span className="flex shrink-0 items-center">{status}</span> : null}
        </Button>
    );
}
